// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__Aawbi","icon":"Skill_icon__z-zW1","elementIcon":"Skill_elementIcon__9a8h4","title":"Skill_title__CVZ6l","description":"Skill_description__nVKg-"};